import { Controller } from "@hotwired/stimulus"

export default class CheckboxesController extends Controller {
  checkAll() {
    for (const el of this.checkboxes) {
      el.checked       = true;
      el.indeterminate = false;
    }
  }

  uncheckAll() {
    for (const el of this.checkboxes) {
      el.checked       = false;
      el.indeterminate = false;
    }
  }

  get checkboxes() {
    return this.element.querySelectorAll('input[type=checkbox]');
  }
}
